import React from 'react';
import { Typography, Box, Container, Grid, Card, CardContent, Rating, Avatar, Stack } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { yellowGlowSx } from '../theme';
const testimonials = [{
  name: 'Linda M.',
  location: 'Brentwood, CA',
  quote: 'From design to install, the team was professional and on time. Our new patio cover completely transformed how we use the backyard.',
  initial: 'L'
}, {
  name: 'David R.',
  location: 'Discovery Bay, CA',
  quote: 'Great communication and quality work. The polycarbonate cover keeps the patio bright but blocks the heat — exactly what we wanted.',
  initial: 'D'
}, {
  name: 'Sarah K.',
  location: 'Antioch, CA',
  quote: 'The free consultation was genuinely helpful, no pressure at all. The finished pergola looks like it was always part of the house.',
  initial: 'S'
}];
export function Testimonials() {
  return <Box component="section" sx={{
    py: {
      xs: 8,
      md: 12
    },
    bgcolor: 'white'
  }} data-id="element-173">
      <Container maxWidth="lg" data-id="element-174">
        <Box sx={{
        textAlign: 'center',
        mb: 8,
        maxWidth: '720px',
        mx: 'auto'
      }} data-id="element-175">
          <Typography variant="h6" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} gutterBottom sx={yellowGlowSx} data-id="element-176">
            Testimonials
          </Typography>
          <Typography variant="h2" color="primary.main" sx={{
          fontSize: {
            xs: '2.25rem',
            md: '3rem'
          }
        }} data-id="element-177">
            Loved by Local Homeowners
          </Typography>
        </Box>

        <Grid container spacing={4} data-id="element-178">
          {testimonials.map(t => <Grid item xs={12} md={4} key={t.name} data-id="element-179">
              <Card sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            p: 1
          }} data-id="element-180">
                <CardContent sx={{
              p: 3,
              flexGrow: 1
            }} data-id="element-181">
                  <FormatQuoteIcon color="secondary" sx={{
                fontSize: 40,
                mb: 1
              }} data-id="element-182" />
                  <Rating value={5} readOnly size="small" sx={{
                mb: 2
              }} data-id="element-183" />
                  <Typography variant="body1" color="text.secondary" sx={{
                lineHeight: 1.7,
                mb: 3
              }} data-id="element-184">
                    “{t.quote}”
                  </Typography>
                  <Stack direction="row" spacing={2} alignItems="center" data-id="element-185">
                    <Avatar sx={{
                  bgcolor: 'primary.main'
                }} data-id="element-186">
                      {t.initial}
                    </Avatar>
                    <Box data-id="element-187">
                      <Typography variant="subtitle1" color="primary.main" fontWeight="bold" data-id="element-188">
                        {t.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" data-id="element-189">
                        {t.location}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>)}
        </Grid>
      </Container>
    </Box>;
}